import {
    Component,
    Inject,
    input,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import {
    FormGroup,
    FormBuilder,
    FormControl,
    FormArray,
    ReactiveFormsModule,
} from '@angular/forms';
import { Apollo, gql, QueryRef } from 'apollo-angular';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {
    DeleteAiDeliverableDocument,
    DeleteAiDeliverableMutation,
    ProductAiDeliverableSearchDocument,
    ProductAiDeliverableSearchQuery,
    UpdateAiDeliverableDocument,
    UpdateAiDeliverableMutation,
} from 'src/__generated__/graphql';

const COLUMNS_SCHEMA = [
    {
        key: 'amount',
        type: 'text',
        label: 'Amount',
    },
    {
        key: 'unit',
        type: 'text',
        label: 'Unit',
    },
    {
        key: 'summary',
        type: 'text',
        label: 'Summary',
    },
    {
        key: 'action',
        type: 'text',
        label: 'action',
    },
];

@Component({
    selector: 'app-product-ai-deliverables',
    templateUrl: './product-ai-deliverables.component.html',
    styleUrl: './product-ai-deliverables.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatTableModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatIconModule,
        MatButtonModule,
    ],
})
export class ProductAiDeliverablesComponent {
    public VOForm!: FormGroup;
    productId = input.required<string>();
    productAiDeliverableQuery?: QueryRef<ProductAiDeliverableSearchQuery>;
    productDeliverableSubscription?: Subscription;
    productDeliverable = new MatTableDataSource<any>();
    public mappingGroup!: FormGroup;
    columnsSchema: any = COLUMNS_SCHEMA;
    displayedColumns: string[] = COLUMNS_SCHEMA.map((col) => col.key);

    constructor(
        private apollo: Apollo,
        private fb: FormBuilder,
        private _formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit(): void {
        this.LoadData();
    }

    EditSVO(VOFormElement: any, i: any) {
        VOFormElement.get('VORows').at(i).get('isEditable').patchValue(false);
    }

    SaveVO(VOFormElement: any, i: any) {
        VOFormElement.get('VORows').at(i).get('isEditable').patchValue(true);
        var deliverableID = VOFormElement.get('VORows')
            .at(i)
            .get('deliverableId').value;
        var amount = parseFloat(
            VOFormElement.get('VORows').at(i).get('amount').value,
        );
        var summary = VOFormElement.get('VORows').at(i).get('summary').value;
        var unit = VOFormElement.get('VORows').at(i).get('unit').value;
        var locale = 'En';

        this.apollo
            .mutate<UpdateAiDeliverableMutation>({
                mutation: UpdateAiDeliverableDocument,
                errorPolicy: 'all',
                variables: {
                    input: {
                        productId: this.productId(),
                        deliverableId: deliverableID,
                        amount: amount,
                        summary: summary,
                        unit: unit,
                        locale: locale,
                    },
                },
            })
            .subscribe(
                ({ data }) => {},
                (error) => {
                    console.log('error', JSON.stringify(error));
                },
            );
    }

    CancelSVO(VOFormElement: any, i: any) {
        VOFormElement.get('VORows').at(i).get('isEditable').patchValue(true);
    }

    Delete(VOFormElement: any, i: any) {
        VOFormElement.get('VORows').at(i).get('isEditable').patchValue(true);
        var deliverableID = VOFormElement.get('VORows')
            .at(i)
            .get('deliverableId').value;

        this.apollo
            .mutate<DeleteAiDeliverableMutation>({
                mutation: DeleteAiDeliverableDocument,
                errorPolicy: 'all',
                variables: {
                    input: {
                        productId: this.productId(),
                        deliverableId: deliverableID,
                    },
                },
            })
            .subscribe(
                ({ data }) => {
                    this.productDeliverable.data.splice(i, 1);
                    this.productDeliverable._updateChangeSubscription();
                },
                (error) => {
                    console.log('error', JSON.stringify(error));
                },
            );
    }

    LoadData() {
        this.VOForm = this.fb.group({
            VORows: this._formBuilder.array([]),
        });

        this.productAiDeliverableQuery =
            this.apollo.watchQuery<ProductAiDeliverableSearchQuery>({
                query: ProductAiDeliverableSearchDocument,
                fetchPolicy: 'network-only',
                variables: {
                    where: { productIds: { in: this.productId() } },
                },
            });
        this.productDeliverableSubscription =
            this.productAiDeliverableQuery.valueChanges.subscribe((result) => {
                const dataFound =
                    result?.data?.marketplaceProductSearch?.items?.[0]
                        ?.aiDeliverables ?? [];

                this.VOForm = this.fb.group({
                    VORows: this.fb.array(
                        dataFound.map((val) =>
                            this.fb.group({
                                amount: new FormControl(val.amount),
                                unit: new FormControl(val.unit),
                                summary: new FormControl(val.summary),
                                deliverableId: new FormControl(
                                    val.deliverableId,
                                ),
                                locale: new FormControl(''),
                                action: new FormControl('existingRecord'),
                                isEditable: new FormControl(true),
                            }),
                        ),
                    ),
                });

                this.productDeliverable = new MatTableDataSource(
                    (this.VOForm.get('VORows') as FormArray).controls,
                );
            });
    }
}
